module.exports = __webpack_public_path__ + "img/tottenham-hotspur.1700cd53.png";